import { selectApiData } from 'util/selector/apiSelector';

import { WithData } from 'api/interfaces';
import { AxiosInstance } from 'axios';
import { TimezoneModel, TimezoneDto } from 'api/dto/Timezone.dto';

export class TimezoneApi {
  constructor(private api: AxiosInstance) {}

  list(): Promise<TimezoneModel[]> {
    return this.api.get<WithData<TimezoneDto[]>>('/api/v1/timezones').then((response) => {
      return selectApiData(response);
    });
  }
}
